import styled from "styled-components";

const Button = styled.button`
display: block;
margin: 15px auto;
max-width: 350px;
width: 100%;
min-height: 30px;
color: white;
font-size: 20px;
font-family: 'Rowdies', cursive;
box-shadow: 0px 0px 10px 8px black;
border-radius: 10px;
text-align: center;
-webkit-text-stroke-width: 1px;
-webkit-text-stroke-color: rgba(29, 12, 0, 1);`;


const ButtonHome = ({children,primary,font="18px", click}) => 
{
    const css = {
        border:`1px solid ${primary}`,
        background:`linear-gradient(90deg, rgba(0,0,0,1) 0%, ${primary} 50%, rgba(0,0,0,1) 100%)`,
    }

    return <Button onClick={click} style={css}> {children} </Button>
}

export default ButtonHome;